module.exports = __webpack_public_path__ + "static/media/node-js.03cc7059.svg";